const shareImage = require('@/assets/image/modal_share_project.png')
const lang = {
  freePlan: 'トライアル',
  pageTitle: '案件一覧',
  editItemInfo: '編集',
  reportPreparation: '報告書作成',
  share: '共同作業',
  cancel: 'キャンセル',
  storageLife: '保存期限：',
  shareLife: '有効期限：',
  completionReport: '完成報告書',
  copyProject: 'コピー',
  charged: '（有料）',
  groupWork: '共同作業',
  noProject: '案件がありません',
  new: '新規',
  fromButton: 'ボタンから',
  takeThePreviousPhoto: '前写真を撮影して',
  createNew: '案件を作成しましょう。',
  freePlanExpired: '保存期限切れのため、<br><b>{projectNames}</b><br>案件が削除されました。',
  projectHasBeenCanceled: '有効期限切れのため、<br><b>{projectNames}</b><br>共同案件が解除されました。',
  userFreeConstructionExpired: '<div class="modal-expired">保存期限切れのため、<br><b>「{constructionName}」</b><br>案件が削除されました。<br><br><b>有料アカウント</b>では期間や件数の制限なく共同作業できます。</div>',
  userMembershipConstructionExpired: '<div class="modal-expired">保存期限切れのため、<br><b>「{constructionName}」</b><br>案件が削除されました。<br></div>',
  userFreeShareConstructionExpired: '<div class="modal-expired">有効期限が切れたため、<br><b>「{constructionName}」</b><br>の共同作業が解除されました。<br><br><b>有料アカウント</b>では期間や件数の制限なく共同作業できます。</div>',
  userMembershipShareConstructionExpired: '<div class="modal-expired">有効期限が切れたため、<br><b>「{constructionName}」</b><br>の共同作業が解除されました。<br></div>',
  headerUserConstructionExpired: '保存期限の終了',
  headerShareConstructionExpired: '有効期限の終了',
  editProject: {
    title: '案件情報編集',
    projectName: '案件名',
    enterProjectName: '案件名を入力',
    projectAddress: '案件住所',
    enterAddress: '案件住所を入力',
    contractorName: '施工者名',
    enterName: '施工者名を入力',
    charactersRemaining: '残り{remaining}文字',
    success: '案件が更新されました。',
  },
  deleteProject: {
    title: '削除確認',
    constructionWillBeDeleted: '1件の案件が削除されます',
    confirmDelete: '削除した案件情報や写真は、復元できません。本当に削除してよろしいでしょうか？',
    share_user_warning: '※共同作業の設定がされています',
    notDelete: '削除しない',
    delete: '削除する'
  },
  applying: '有料アカウント申込み中',
  free_acccount: '無料アカウント',
  deleted_message: '共同作業案件<br> <strong>「{constructionName}」</strong><br>が案件作成者が削除されました。',
  modal_share: {
    content: '<img src="' + shareImage + '"/>',
    btn_close: '閉じる'
  },
  construction_name_empty: '案件名未入力',
  modal_redirect: {
    btn_apply: '今すぐ申し込む',
    btn_create_report: 'このまま報告書を作成する',
  },
  modal_modified_user: {
    btn_ok: 'OK',
    content: '<b>{userName}</b></br><b>{mail}</b></br> がこの案件を更新しました。</br></br>更新内容を適用して再読み込みします。',
    conflict_detected: '競合が検出されました'
  },
  search_construction: {
    keyword_empty: '検索結果は <br>ここに表示されます',
    search_title: '案件検索',
    search_btn: '検索',
    search_placeholder: '案件名、案件住所、施工者',
    construction_name: '案件名',
    construction_address: '案件住所',
    company_name: '施工者',
    construction_maker: '案件作成者',
    no_result: '検索結果はありません',
    street_address: '住所',
    author: '作成者',
  }
}

export default lang



// WEBPACK FOOTER //
// ./src/lang/ja/pages/project/projectList.js